import { useLanguage } from "../context/LanguageContext";
import { BuyWithConfidence } from "./BuyWithConfidence";
import { Reveal } from "./Reveal";

const FOUNDER_IMAGE =
  "https://customer-assets-lxgj4vgw.emergentagent.net/job_azorunique-home/artifacts/je6fqp6b_Perfil%20Final.png";

export const About = () => {
  const { t } = useLanguage();

  return (
    <section id="sobre-nos" className="py-28 sm:py-36" data-testid="about-section">
      <div className="mx-auto max-w-7xl px-6">
        <BuyWithConfidence />

        <div className="mt-28 grid gap-16 border-t border-white/10 pt-24 lg:grid-cols-2 lg:gap-24">
          <div>
            <Reveal delay={0.1}>
              <h2 className="font-display text-2xl font-normal leading-snug tracking-tight text-sand sm:text-3xl lg:text-4xl" data-testid="about-title">
                {t.about.title}
              </h2>
            </Reveal>
            <Reveal delay={0.18}>
              <p className="mt-8 font-display text-lg italic leading-relaxed text-sand/90 sm:text-xl">
                {t.about.p1}
              </p>
            </Reveal>
            <Reveal delay={0.25}>
              <p className="mt-6 text-sm leading-relaxed text-mist sm:text-base">{t.about.p2}</p>
            </Reveal>
            <Reveal delay={0.28}>
              <p className="mt-8 font-display text-lg italic leading-relaxed text-terracotta sm:text-xl" data-testid="about-tagline">
                {t.about.p3}
              </p>
            </Reveal>

            <Reveal delay={0.3}>
              <div className="mt-14 border-t border-white/10 pt-8" data-testid="about-partner">
                <p className="font-mono text-[11px] uppercase tracking-[0.35em] text-terracotta">
                  {t.about.partnerEyebrow}
                </p>
                <img
                  src="/uaid-logo.png"
                  alt="UAID Arquitetos"
                  className="mt-5 h-16 w-auto"
                  data-testid="about-partner-logo"
                />
                <p className="mt-4 max-w-md text-sm leading-relaxed text-mist">{t.about.partnerText}</p>
              </div>
            </Reveal>
          </div>

          <Reveal delay={0.15}>
            <div className="relative" data-testid="about-founder">
              <div className="absolute -left-3 -top-3 h-full w-full rounded-lg border border-terracotta/40" aria-hidden="true" />
              <div className="relative overflow-hidden rounded-lg">
                <img
                  src={FOUNDER_IMAGE}
                  alt={t.about.founderName}
                  loading="lazy"
                  className="aspect-[4/5] w-full object-cover object-[68%_center]"
                  data-testid="about-founder-image"
                />
                <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-basalt via-basalt/60 to-transparent p-7 pt-20">
                  <p className="font-display text-2xl text-sand" data-testid="about-founder-name">
                    {t.about.founderName}
                  </p>
                  <p className="mt-1 font-mono text-[11px] uppercase tracking-[0.25em] text-terracotta" data-testid="about-founder-role">
                    {t.about.founderRole}
                  </p>
                </div>
              </div>
              <div className="mt-6 space-y-4" data-testid="about-founder-bio">
                {(Array.isArray(t.about.founderBio) ? t.about.founderBio : [t.about.founderBio]).map((para, i) => (
                  <p key={i} className="text-sm leading-relaxed text-mist">
                    {para}
                  </p>
                ))}
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
